import React from 'react';
import { useIntl } from 'react-intl';
import { isBefore } from 'date-fns';

import { Box, AlertCallout } from 'baukasten';

import { PublicAccount } from 'types/Account';

import messages from '../messages';

type AccountNotificationsProps = {
  account?: Pick<PublicAccount, 'subscriptionEndDate' | 'trialEndDate'>;
};

export const AccountNotifications = ({
  account,
}: AccountNotificationsProps) => {
  const { formatMessage } = useIntl();

  if (!account) {
    return null;
  }

  const isTrialExpired =
    account.trialEndDate &&
    isBefore(new Date(account.trialEndDate), new Date());

  const isSubscriptionExpired =
    account.subscriptionEndDate &&
    isBefore(new Date(account.subscriptionEndDate), new Date());

  if (isTrialExpired || isSubscriptionExpired) {
    return (
      <Box mb={8}>
        <AlertCallout
          message={formatMessage(
            isTrialExpired
              ? messages.trialExpiredNotice
              : messages.subscriptionExpiredNotice
          )}
        />
      </Box>
    );
  }

  return null;
};
